import {toast} from "react-toastify";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";

const SubmitDataHandler = async (sendData, setSendData, navigateTo) => {

  let isValid = true

  if (sendData?.documentCode === "") {
    return toast.error("شماره سند را وارد کنید")
  }
  if (sendData?.documentDate === "") {
    return toast.error("تاریخ سند را وارد کنید")
  }
  if (sendData?.documentTime === "") {
    return toast.error("زمان سند را وارد کنید")
  }

  if (sendData?.documentDetails.length === 0) {
    return toast.error("اطلاعات به درستی وارد نشده")
  }
  sendData?.documentDetails.forEach((item, index) => {
    if (item?.accountCode_3 === "") {
      isValid = false
      return toast.error("عنوان حساب ردیف " + (index + 1) + " مشخص نشده است")
    }
  })
  sendData?.documentDetails.forEach((item, index) => {
    if (item?.hasSubAccount && item?.accountCode_4 === "") {
      isValid = false
      return toast.error("تفصیلی ردیف " + (index + 1) + " مشخص نشده است")
    }
  })

  if (isValid) {
    let bed = 0
    let bes = 0
    sendData?.documentDetails.forEach((item) => {
      bed = bed + +item?.bed
      bes = bes + +item?.bes
    })
    if (+bed !== +bes) {
      isValid = false
      return toast.error("سند حسابداری تراز نیست. مانده تا تراز شدن " + UtilsFunctions.addCommas(bed - bes))
    }
  }

  if (isValid) {
    const Data = {
      request: "documentConfirm",
      data: {...sendData}
    }
    const response = await _axios.post(prefixUrl() + "/accountingDocument/", Data)
    if (response.data?.status) {
      toast.success(response?.data?.message)
      if (sendData?.mode === "add") {
        setSendData({
          mode: "add",
          documentCode: "",
          documentDescription: "",
          documentDate: "",
          documentTime: "",
          documentDetails: [
            {
              uniqId: Math.random() * 13,
              accountCode_3: "",
              accountCode_4: "",
              description: "",
              hasSubAccount: false,
              bed: "0",
              bes: "0"
            },
          ]
        })
      } else {
        navigateTo("/List/documents")
      }
    } else {
      toast.error(response?.data?.message)
    }
  }
};

export default SubmitDataHandler;